import { call, put, fork, takeLatest } from 'redux-saga/effects';
import { REQUEST_FIELD_DETAILS } from '../constants/actionTypes';
import { failureFieldData, receiveFieldDetails } from '../actions/fieldActions';
import { requestFieldDetails } from '../requesters/fieldRequesters';

export function* getFieldDetails(action) {
  try {
    const { id, uuid, centroid } = yield call(
      requestFieldDetails,
      action.fieldId
    );

    yield put(receiveFieldDetails({ id, uuid, centroid }));
  } catch (error) {
    yield put(failureFieldData(error));
  }
}

export function* getFieldDetailsWatcher() {
  yield takeLatest(REQUEST_FIELD_DETAILS, getFieldDetails);
}

export default function* rootSaga() {
  yield fork(getFieldDetailsWatcher);
}
